/* Conecta's catch-all entries ("Otros Modelos Chevrolet", and the "Versión otra" Salfa plans
   to add) let the user schedule a vehicle missing from the catalog. Sorted alphabetically
   they ended up in the middle of the list, so they go last, like the "Otros" brand card. */
const isOtherOption = (item) => /\botr[oa]s?\b/i.test(item.name);

const byCatalogOrder = (a, b) =>
  Number(isOtherOption(a)) - Number(isOtherOption(b)) || a.name.localeCompare(b.name);

export default byCatalogOrder;
